export type Arrow = "below" | "above" | "right" | "left";

/**
 * Translate Floating-UI library popover position name to Spark's caret position
 * @param  {string} term Name of Floating-UI's position
 * @return {string}      Name of Spark caret
 */
export const matchCaretKey = (term: string): Arrow => {
  switch (term) {
    case "top":
      return "above";
    case "bottom":
      return "below";
    case "bottom-start":
      return "below";
    case "right":
      return "right";
    case "top-start":
      return "above";
    case "bottom-end":
      return "below";
    case "left":
      return "left";
    case "top-end":
      return "above";
    default:
      return "below";
  }
};
